import { createContext } from "react";

const PlnnerContext = createContext(undefined as any);

export default PlnnerContext;
